document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-stack-builder]');
  if (!root) return;

  var discountPercent = parseFloat(root.getAttribute('data-discount-percent')) || 0;
  var minCharms = parseInt(root.getAttribute('data-min-charms'), 10) || 2;

  var state = {
    necklaces: new Map(),
    charms: new Map()
  };

  var necklaceCards = root.querySelectorAll('[data-necklace-card]');
  var charmCards = root.querySelectorAll('[data-charm-card]');
  var summaryNecklace = root.querySelector('[data-summary-necklace]');
  var summaryCharms = root.querySelector('[data-summary-charms]');
  var nudgeEl = root.querySelector('[data-stack-nudge]');
  var subtotalEl = root.querySelector('[data-summary-subtotal]');
  var discountEl = root.querySelector('[data-summary-discount]');
  var totalEl = root.querySelector('[data-summary-total]');
  var addButton = root.querySelector('[data-add-stack]');
  var statusEl = root.querySelector('[data-stack-status]');
  var summaryHeading = root.querySelector('[data-stack-summary] h2');

  // Customer-facing text comes from the locale file via Liquid (sections/stack-builder.liquid).
  var strings = {
    remove: 'Remove [name]',
    decreaseQuantity: 'Decrease quantity of [name]',
    increaseQuantity: 'Increase quantity of [name]',
    quantity: 'Quantity',
    onlyAvailable: 'Only [count] available',
    removed: '[name] removed from your stack',
    quantityChanged: '[name]: quantity [count]'
  };
  try {
    var stringsEl = root.querySelector('[data-stack-strings]');
    if (stringsEl) Object.assign(strings, JSON.parse(stringsEl.textContent));
  } catch (e) { /* keep defaults */ }

  function t(key, vars) {
    var text = strings[key];
    Object.keys(vars || {}).forEach(function (name) {
      text = text.split('[' + name + ']').join(vars[name]);
    });
    return text;
  }

  // Units of each variant already in the cart. Shopify checks stock across the whole
  // cart, so they come off each item's limit. Refreshed on load and after each add.
  var cartQuantities = {};

  function announce(message) {
    if (!statusEl) return;
    // Clear first so repeating the same message is still announced.
    statusEl.textContent = '';
    window.setTimeout(function () { statusEl.textContent = message; }, 50);
  }

  var ESCAPE_MAP = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (ch) { return ESCAPE_MAP[ch]; });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // How many more of a card's variant can be added, or null when there's no cap.
  // data-inventory is only set when Shopify tracks stock and won't oversell.
  function remainingFor(card) {
    var inventory = parseInt(card.getAttribute('data-inventory'), 10);
    if (isNaN(inventory)) return null;
    return Math.max(inventory - (cartQuantities[card.getAttribute('data-variant-id')] || 0), 0);
  }

  function itemFromCard(card) {
    return {
      variantId: card.getAttribute('data-variant-id'),
      title: card.getAttribute('data-title'),
      price: parseInt(card.getAttribute('data-price'), 10),
      quantity: 1,
      card: card
    };
  }

  function lineHtml(item, role) {
    var max = remainingFor(item.card);
    var atMax = max !== null && item.quantity >= max;
    var name = item.title;
    return (
      '<div class="stack-builder__summary-line">' +
        '<span class="stack-builder__summary-title">' + escapeHtml(name) + '</span>' +
        '<span>' + formatMoney(item.price * item.quantity) + '</span>' +
      '</div>' +
      '<div class="stack-builder__qty" data-qty-role="' + role + '" data-qty-id="' + escapeHtml(item.variantId) + '">' +
        '<button type="button" class="stack-builder__qty-btn" data-qty-change="-1" aria-label="' +
          escapeHtml(item.quantity === 1 ? t('remove', { name: name }) : t('decreaseQuantity', { name: name })) + '">&minus;</button>' +
        '<span class="stack-builder__qty-value"><span class="visually-hidden">' + escapeHtml(t('quantity')) + ' </span>' + item.quantity + '</span>' +
        '<button type="button" class="stack-builder__qty-btn" data-qty-change="1" aria-label="' + escapeHtml(t('increaseQuantity', { name: name })) + '"' +
          (atMax ? ' disabled' : '') + '>+</button>' +
        (atMax ? '<span class="stack-builder__qty-limit">' + escapeHtml(t('onlyAvailable', { count: max })) + '</span>' : '') +
      '</div>'
    );
  }

  function totalQuantity(items) {
    var count = 0;
    items.forEach(function (item) { count += item.quantity; });
    return count;
  }

  function render() {
    // Summary lines are rebuilt each time, so restore focus to the stepper button that was used.
    var active = document.activeElement;
    var focusKey = null;
    if (active && active.hasAttribute && active.hasAttribute('data-qty-change')) {
      var activeQty = active.closest('[data-qty-id]');
      focusKey = [activeQty.getAttribute('data-qty-role'), activeQty.getAttribute('data-qty-id'), active.getAttribute('data-qty-change')];
    }

    if (state.necklaces.size) {
      var necklaceLines = '';
      state.necklaces.forEach(function (necklace) {
        necklaceLines += '<li class="stack-builder__summary-item">' + lineHtml(necklace, 'necklace') + '</li>';
      });
      summaryNecklace.innerHTML = '<ul class="stack-builder__summary-list">' + necklaceLines + '</ul>';
    } else {
      summaryNecklace.innerHTML = '<p class="stack-builder__summary-empty">Pick a necklace to get started.</p>';
    }

    summaryCharms.innerHTML = '';
    state.charms.forEach(function (charm) {
      var li = document.createElement('li');
      li.className = 'stack-builder__summary-item';
      li.innerHTML = lineHtml(charm, 'charm');
      summaryCharms.appendChild(li);
    });

    if (focusKey) {
      var target = root.querySelector('[data-qty-role="' + focusKey[0] + '"][data-qty-id="' + focusKey[1] + '"] [data-qty-change="' + focusKey[2] + '"]');
      if (target && !target.disabled) {
        target.focus();
      } else {
        // The line hit its limit or was removed: keep focus inside the summary
        // (the add button may be disabled, so it can't take focus).
        var fallback = (target && target.parentNode.querySelector('[data-qty-change="-1"]')) ||
          root.querySelector('[data-stack-summary] [data-qty-change]:not(:disabled)') ||
          summaryHeading;
        fallback.focus();
      }
    }

    var subtotal = 0;
    state.necklaces.forEach(function (necklace) { subtotal += necklace.price * necklace.quantity; });
    state.charms.forEach(function (charm) { subtotal += charm.price * charm.quantity; });

    // Any necklace plus enough charms qualifies. Charm quantities count toward the
    // minimum, matching the cart nudge (cart-nudge.js).
    var hasNecklace = state.necklaces.size > 0;
    var charmCount = totalQuantity(state.charms);
    var qualifiesForDiscount = hasNecklace && charmCount >= minCharms;
    var discount = qualifiesForDiscount ? Math.round(subtotal * (discountPercent / 100)) : 0;

    subtotalEl.textContent = formatMoney(subtotal);
    discountEl.textContent = '\u2212' + formatMoney(discount);
    totalEl.textContent = formatMoney(subtotal - discount);

    if (nudgeEl) {
      var charmsNeeded = minCharms - charmCount;
      if (hasNecklace && !qualifiesForDiscount && charmsNeeded > 0) {
        var charmWord = charmsNeeded === 1 ? 'charm' : 'charms';
        nudgeEl.textContent = 'Add ' + charmsNeeded + ' more ' + charmWord + ' to unlock ' + discountPercent + '% off';
        nudgeEl.hidden = false;
      } else {
        nudgeEl.hidden = true;
      }
    }

    addButton.disabled = !hasNecklace;
  }

  function cardFor(cards, variantId) {
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].getAttribute('data-variant-id') === variantId) return cards[i];
    }
    return null;
  }

  root.querySelector('[data-stack-summary]').addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrap = btn.closest('[data-qty-id]');
    var role = wrap.getAttribute('data-qty-role');
    var variantId = wrap.getAttribute('data-qty-id');
    var items = role === 'necklace' ? state.necklaces : state.charms;
    var item = items.get(variantId);
    if (!item) return;

    var next = item.quantity + parseInt(btn.getAttribute('data-qty-change'), 10);
    var max = remainingFor(item.card);
    if (max !== null && next > max) return;

    if (next < 1) {
      announce(t('removed', { name: item.title }));
      items.delete(variantId);
      setSelected(cardFor(role === 'necklace' ? necklaceCards : charmCards, variantId), false);
    } else {
      item.quantity = next;
      announce(t('quantityChanged', { name: item.title, count: next }));
    }
    render();
  });

  function setSelected(card, selected) {
    if (!card) return;
    card.classList.toggle('is-selected', selected);
    card.setAttribute('aria-pressed', selected ? 'true' : 'false');
  }

  // Apply the current cart to the cards and the stack: a variant whose stock is all
  // in the cart can't be picked, and selected quantities shrink to what's left.
  function syncAvailability() {
    [[necklaceCards, state.necklaces], [charmCards, state.charms]].forEach(function (pair) {
      pair[0].forEach(function (card) {
        var badge = card.querySelector('[data-in-cart-badge]');
        if (!badge) return; // sold out at page load, or stock isn't tracked
        var remaining = remainingFor(card);
        var none = remaining === 0;
        card.disabled = none;
        card.classList.toggle('is-soldout', none);
        badge.hidden = !none;
        if (none) {
          card.removeAttribute('aria-pressed');
          card.setAttribute('aria-disabled', 'true');
        } else {
          card.removeAttribute('aria-disabled');
          card.setAttribute('aria-pressed', card.classList.contains('is-selected') ? 'true' : 'false');
        }

        var item = pair[1].get(card.getAttribute('data-variant-id'));
        if (!item) return;
        if (none) {
          pair[1].delete(item.variantId);
          card.classList.remove('is-selected');
        } else if (remaining !== null && item.quantity > remaining) {
          item.quantity = remaining;
        }
      });
    });
    render();
  }

  function refreshCartQuantities() {
    var base = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return fetch(base + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        cartQuantities = {};
        cart.items.forEach(function (line) {
          var id = String(line.variant_id);
          cartQuantities[id] = (cartQuantities[id] || 0) + line.quantity;
        });
        syncAvailability();
      })
      .catch(function () { /* keep the page-load limits */ });
  }

  // Necklace and charm cards both toggle in and out of the stack.
  function bindCards(cards, items) {
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        var variantId = card.getAttribute('data-variant-id');
        if (items.has(variantId)) {
          items.delete(variantId);
          setSelected(card, false);
        } else {
          items.set(variantId, itemFromCard(card));
          setSelected(card, true);
        }
        render();
      });
    });
  }
  bindCards(necklaceCards, state.necklaces);
  bindCards(charmCards, state.charms);

  addButton.addEventListener('click', function () {
    if (!state.necklaces.size) return;

    addButton.disabled = true;
    addButton.textContent = 'Adding\u2026';

    var items = [];
    state.necklaces.forEach(function (necklace) {
      items.push({
        id: necklace.variantId,
        quantity: necklace.quantity,
        properties: { '_stack_role': 'Necklace' }
      });
    });
    state.charms.forEach(function (charm) {
      items.push({
        id: charm.variantId,
        quantity: charm.quantity,
        properties: { '_stack_role': 'Charm' }
      });
    });

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) {
          // Shopify explains stock problems in its own (localized) words; prefer those.
          return res.json().catch(function () { return {}; }).then(function (body) {
            var err = new Error('Could not add stack to cart');
            err.shopifyMessage = body && body.description;
            throw err;
          });
        }
        return res.json();
      })
      .then(function (data) {
        addButton.disabled = false;
        addButton.textContent = 'Add stack to cart';
        state.necklaces.clear();
        state.charms.clear();
        necklaceCards.forEach(function (c) { setSelected(c, false); });
        charmCards.forEach(function (c) { setSelected(c, false); });
        render();
        refreshCartQuantities();
        if (window.CartDrawer) {
          window.CartDrawer.open();
        } else {
          window.location.href = window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_url
            ? window.Shopify.routes.cart_url
            : '/cart';
        }
      })
      .catch(function (err) {
        addButton.disabled = false;
        addButton.textContent = 'Add stack to cart';
        alert((err && err.shopifyMessage) || 'Something went wrong adding your stack. Please try again.');
        refreshCartQuantities();
      });
  });

  render();
  refreshCartQuantities();
});
